import saveRESalePropsService from "./saveRESalePropsService";
import saveRESalePropsPortfolioService from "./saveRESalePropsPortfolioService";

export default ({ saleId, propertyId, values }) =>
  Promise.all([
    saveRESalePropsService({ saleId, propertyId }),
    saveRESalePropsPortfolioService({ saleId, propertyId, values })
  ]);
